import {
  CH_CO_SUPER_ADMIN_IDS,
  CHCO_ORGANIZATION_ID,
  hasRestrictedFeatures,
  DELAWARE_NORTH_ID,
  LEGENDS_GRABD_RAPID_SUPER_ADMIN_IDS,
  LEGENDS_US_ORGANIZATION_ID,
  LEVY_SUPER_ADMIN_IDS
} from '@ubeya/shared/utils/accounts';

export const BLOCKED_SETTINGS_ADMIN_EMAILS = new Set([
  'elev8recruit@gmail.com',
  'mosamwiki@gmail.com',
  'phoenix.lowdermilk@gmail.com'
]);

export const isAdminBlockedFromSettings = ({ email: adminEmail, isRestrictedFromEmployees = false }) => {
  if (isRestrictedFromEmployees) {
    return true;
  }

  if (!adminEmail) {
    return false;
  }
  return BLOCKED_SETTINGS_ADMIN_EMAILS.has(adminEmail);
};

/** Organizations that get the partial Settings view, and the admins who keep the full one. */
const FULL_SETTINGS_ADMIN_IDS_BY_ORGANIZATION = {
  [CHCO_ORGANIZATION_ID]: CH_CO_SUPER_ADMIN_IDS,
  [LEGENDS_US_ORGANIZATION_ID]: LEGENDS_GRABD_RAPID_SUPER_ADMIN_IDS
};

export const checkIfShowPartialSettingsView = ({ isUbeyaAdmin, adminId, accountId, organizationId }) => {
  if (isUbeyaAdmin) {
    return false;
  }

  // Delaware North takes the restricted feature set everywhere else, but keeps full Settings.
  if (accountId === DELAWARE_NORTH_ID) {
    return false;
  }

  if (hasRestrictedFeatures({ accountId, organizationId })) {
    return !LEVY_SUPER_ADMIN_IDS.includes(adminId);
  }

  const fullSettingsAdminIds = FULL_SETTINGS_ADMIN_IDS_BY_ORGANIZATION[organizationId];
  if (!fullSettingsAdminIds) {
    return false;
  }

  return !fullSettingsAdminIds.includes(adminId);
};
